import React from 'react';
import { Shield } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import LegalPageLayout from '../components/LegalPageLayout';

const PrivacyPolicy = ({ embedded = false }) => {
  const { lang } = useLanguage();
  const english = lang === 'en';

  return (
    <LegalPageLayout
      embedded={embedded}
      icon={Shield}
      title={english ? 'Privacy Policy' : 'Privacybeleid'}
      updated={english ? 'Last updated: February 2026' : 'Laatst bijgewerkt: februari 2026'}
      backLabel={english ? 'Back to Home' : 'Terug naar Home'}
      testId="privacy-back-btn"
    >
          {english ? <>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. Introduction</h2>
          <p>Krypton9 ("we", "us", "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy describes how we collect, use, and protect information when you use our services.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Data we collect</h2>
          <p>We may collect the following data:</p>
          <ul>
            <li>Name, email address, phone number, and company name when you submit a contact form</li>
            <li>Account details when you register on our platform</li>
            <li>Usage and interaction data within the platform</li>
            <li>Technical data such as your IP address and browser type</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. How we use your data</h2>
          <p>We use your data to:</p>
          <ul>
            <li>Provide and improve our services</li>
            <li>Communicate with you about your requests and our services</li>
            <li>Comply with legal obligations</li>
            <li>Send our newsletter (only with your consent)</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Data protection</h2>
          <p>We take appropriate technical and organizational measures to protect your personal data against unauthorized access, loss, or misuse.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Your rights</h2>
          <p>Under the General Data Protection Regulation (GDPR), you have the right to:</p>
          <ul>
            <li>Request access to your personal data</li>
            <li>Request correction or deletion of your data</li>
            <li>Object to processing</li>
            <li>Transfer your data (data portability)</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>6. Contact</h2>
          <p>If you have questions about this Privacy Policy, contact us at:</p>
          <p style={{ fontWeight: 500 }}>Email: info@krypton9.com</p>
          </> : <>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. Inleiding</h2>
          <p>Krypton9 ("wij", "ons", "onze") respecteert uw privacy en is toegewijd aan het beschermen van uw persoonsgegevens. Dit Privacybeleid beschrijft hoe wij informatie verzamelen, gebruiken en beschermen wanneer u onze diensten gebruikt.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Welke gegevens verzamelen wij</h2>
          <p>Wij kunnen de volgende gegevens verzamelen:</p>
          <ul>
            <li>Naam, e-mailadres, telefoonnummer en bedrijfsnaam bij het invullen van contactformulieren</li>
            <li>Accountgegevens bij registratie op ons platform</li>
            <li>Gebruiksdata en interactiegegevens binnen het platform</li>
            <li>Technische gegevens zoals IP-adres en browsertype</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. Hoe gebruiken wij uw gegevens</h2>
          <p>Wij gebruiken uw gegevens om:</p>
          <ul>
            <li>Onze diensten te leveren en te verbeteren</li>
            <li>Met u te communiceren over uw verzoeken en onze diensten</li>
            <li>Wettelijke verplichtingen na te komen</li>
            <li>Onze nieuwsbrief te verzenden (alleen met uw toestemming)</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Gegevensbescherming</h2>
          <p>Wij nemen passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen tegen ongeoorloofde toegang, verlies of misbruik.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Uw rechten</h2>
          <p>Op grond van de AVG heeft u het recht om:</p>
          <ul>
            <li>Inzage te vragen in uw persoonsgegevens</li>
            <li>Rectificatie of verwijdering te verzoeken</li>
            <li>Bezwaar te maken tegen verwerking</li>
            <li>Uw gegevens over te dragen (dataportabiliteit)</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>6. Contact</h2>
          <p>Voor vragen over dit privacybeleid kunt u contact opnemen via:</p>
          <p style={{ fontWeight: 500 }}>E-mail: info@krypton9.com</p>
          </>}
    </LegalPageLayout>
  );
};

export default PrivacyPolicy;
